import { DataModel } from "@toolpad/core/Crud";

import { IBatteryFirmwareDto } from "../generated/api-client";
import { nameof } from "../utils/object.utils";
import MagicCrud, { MagicCrudFields } from "../components/MagicCrud";
import DownloadButton from "../components/DownloadButton";
import { getBaseUrl } from "../core/config";
import UploadField from "../components/UploadField";
import { axiosInstance } from "../core/axios-interceptors";

type BatteryFirmwareDtoDataModel = IBatteryFirmwareDto & DataModel;

export default function BatteryFirmwaresPage() {
  const columns: MagicCrudFields<IBatteryFirmwareDto>[] = [
    {
      field: nameof<IBatteryFirmwareDto>("id"),
      type: "number",
      extraType: "guid",
    },
    {
      field: nameof<IBatteryFirmwareDto>("description"),
      type: "string",
    },
    {
      field: nameof<IBatteryFirmwareDto>("version"),
      type: "string",
      notInEditMode: true,
      isRequired: true,
    },
    {
      field: nameof<IBatteryFirmwareDto>("released"),
      type: "boolean",
    },
    {
      field: nameof<IBatteryFirmwareDto>("fileUrl"),
      type: "custom",
      notInEditMode: true,
      isRequired: true,
      renderCell: (p) => {
        return (
          <DownloadButton
            fileUrl={`${getBaseUrl()}/batteries/firmwares/${p.row["id"]}/download`}
            fileName={p.value.split("/").pop()}
          ></DownloadButton>
        );
      },
      renderFormField: ({ value, onChange, error }) => (
        <UploadField value={value} onChange={onChange} error={error} />
      ),
    },
  ];

  return (
    <MagicCrud<BatteryFirmwareDtoDataModel>
      name="batteryFirmware"
      apiUrl="batteries/firmwares"
      columns={columns}
      appUrl="/battery-firmwares"
      customCreateOne={async (data) => {
        const formData = new FormData();
        formData.append("version", data.version!);
        formData.append("file", data.fileUrl!);
        formData.append("description", data.description!);
        formData.append("released", data.released ? "true" : "false");
        const res = await axiosInstance.post<BatteryFirmwareDtoDataModel>(
          `${getBaseUrl()}/batteries/firmwares`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        return res.data;
      }}
    />
  );
}
